
import React, { useEffect } from 'react';
import { activityBeam } from 'src/services/Profiles';

let activeBeam: any = null;

export const ActiveUser = () => {
    useEffect(() => {
        startActivityBeam();
        return () => {
            clearInterval(activeBeam)
        }
    }, []);

    const startActivityBeam = () => {
        clearInterval(activeBeam);
        activeBeam = setInterval(activityBeam, 60000);
    }
    return null
}

export default ActiveUser;